/**
 * 
 * Text Field
 * 
 */

import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Label, Input, FormGroup, Button } from 'reactstrap'


function TransportDetailField(props) {
    const {  onChange, isInvalid ,value} = props
    
    const [list, SetList] = useState(value&& value.length!='0'?value:[{  vehicleNumber: "" ,vehicleType:""}])
    
    const handelListAdd = () => {
        SetList([...list, {  vehicleNumber: "" ,vehicleType:""}])
    }
    const handelRemove = (index) => {
        const data = [...list]
        data.splice(index, 1)
        SetList(data)
    }
    const handleOnChange = (e, index) => {
        const { name, value } = e.target
        const data = [...list]
        data[index][name] = value
        SetList(data)
    }
    return (
        <React.Fragment >

            {list.map((singleInput, index) => {
                return [
                    <>
                        <div className='row my-3'>
                            <FormGroup className='no-margin col-4 col-md-4'>
                                <Label className='' htmlFor={'vehicleNumber' + index}>
                                    Vehicle Number
                                </Label>

                                <Input
                                    key={'vehicleNumber' }
                                    type="text"
                                    className="form-control mr-2"
                                    name={'vehicleNumber'}
                                    value={singleInput.vehicleNumber}
                                    onChange={(e) => {handleOnChange(e, index)
                                        onChange({target: { value: list}})
                                    }}
                                    id={'vehicleNumber' }
                                    disabled={false}
                                    placeholder='Enter Vehicle Number'
                                    invalid={isInvalid ? true : false}
                                />
                            </FormGroup>

                            <FormGroup className='no-margin col-4 col-md-4'>
                                <Label className='' htmlFor={'vehicleType' + index}>
                                    Vehicle Type
                                </Label>

                                <Input
                                    key={'vehicleType'}
                                    type="text"
                                    className="form-control mr-1"
                                    name={'vehicleType' }
                                    value={singleInput.vehicleType}

                                    onChange={(e) =>{ handleOnChange(e, index)
                                    
                                        onChange({target: { value: list}})
                                    }
                                    }
                                    id={'vehicleType' }
                                    placeholder='Enter Vehicle Type'
                                    invalid={isInvalid ? true : false}
                                />
                            </FormGroup>
                            <FormGroup className='no-margin col-4 col-md-4 ml-3'>
                                {list.length > 1 && <Button className='btn-danger'  type="button"  style={{width:'40%','marginRight':'15px','marginTop':'26px'}}  onClick={() => handelRemove(index)}>Remove</Button>}
                                {list.length===index+1 && <Button className='btn-success ' type="button"  onChange={onChange} value={list} style={{width:'40%','marginTop':'26px'}} onClick={handelListAdd}>Add</Button>}

                            </FormGroup>
                        </div>

                    </>

                ]
            }
            )

            }
        </React.Fragment>
    )
}

TransportDetailField.propTypes = {
    t: PropTypes.any,
    onChange: PropTypes.func,
    isInvalid: PropTypes.any,
    value: PropTypes.any,
}

export default TransportDetailField